export default __webpack_public_path__ + "static/media/2.b2fe7d61.jpg";